<template>
  <div
    id="f-alert-jpt-mobile-app"
    style="display: none;"
  >
    <b-alert
      v-if="state.alert"
      :show="state.alert"
      variant="jpt-mobile-app"
      dismissible
      :dismiss-label="$t('txt.close')"
      @dismissed="state.alert = false; cookie('w', 'f-alert-jpt-mobile-app', true, 259200000);"
    >
      <b-row
        class="flex-column"
      >
        <b-col
          class="d-flex align-items-center justify-content-between"
        >
          <img
            class="d-none d-sm-block"
            :src="`${$t('baseurl')}img/com/c25/sepia-crowdfunding-mobile.webp`"
            alt="Sepia, the PeerTube mascot"
            width="150"
            height="118"
          />
          <div
            class="jpt-mobile-app-message"
            v-html="$t('alert.peertube-mobile-app.md')"
          ></div>
        </b-col>
        <b-col class="text-right pr-4">
          <a
            class="btn btn-sm btn-outline-warning"
            target="_blank"
            :href="`https://support.joinpeertube.org/?mtm_campaign=JPTMobileApp25&mtm_source=Framanav&mtm_placement=Alert1`"
          >
            <strong v-html="$t('alert.peertube-mobile-app.btn')"></strong>
          </a>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      state: {
        alert: !this.cookie('r', 'f-alert-jpt-mobile-app'),
      },
    };
  },
};
</script>

<style lang="scss">
#f-- #fp-alert .alert-jpt-mobile-app {
  --f-i9: #0b1c54;
  background: #fce8db;
  border: 1px solid #FFC99E;
  padding: 0.75rem 0 0.5rem 0;
  background-size: cover;
  color: #212529;

  .close {
    color: var(--f-i9);
    padding: .25rem 0;
  }

  div {
    h1 {
      text-align: left;
      background: #fce8db;
      color: #212529;
      font-family: 'Tovari Sans';
      font-size: 1.75rem;
      line-height: 1.75rem;
      margin: 0;
      padding: .5rem .75rem .5rem .5rem;
    }

    p {
      color: #212529;
      background: #fce8db;
      padding: .5rem .75rem;
      margin: 0;
      // max-width: calc(7 / 12 * 100%);
    }

    .btn-outline-warning {
      font-size: .875rem !important;
      padding: 8px 32px !important;
      text-decoration: none !important;
      font-weight: 700;
      border-radius: 6px;
      text-align: center;
      border: 2px solid #F2690D;
      color: #212529;

      &:hover, &:focus, &:active {
        opacity: .8;
        background: rgba(242,105,13,.1);
        color: #212529;
      }
    }
  }
}

[data-url*="://framasoft.org"],
[data-url*=".frama.io"],
[data-url*="://support.joinpeertube.org"] {
  #fp-alert {
    display: none !important;
  }
}

.jpt-mobile-app-message {
  max-width: 95vw;
}
</style>
